import { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Layout from 'components/layout';
import { routes } from './routes';
import { SessionContext } from 'contexts/session';
import { useCapabilities } from 'contexts/capabilities';
import useAccountPlanData from 'hooks/useAccountPlanData';
import { FEATURE_FLAGS, useBooleanFlag } from 'hooks/useFeatureFlags';

const ACCOUNT_USERS_ROUTE = '/account/:id/users';

const staffRoutes = [
  '/accounts',
  '/users',
  '/user/:id',
  '/account/:id',
  ACCOUNT_USERS_ROUTE,
  '/rax',
  '/genAI',
  '/custom-content',
];

const Routes = (): JSX.Element => {
  const { account, isStaff, isAccountOwner, isTeamManager } = useContext(SessionContext);
  const { isExpired } = useAccountPlanData({ account });
  const isCustomContentEnabled = useBooleanFlag(FEATURE_FLAGS.CUSTOM_CONTENT_ENABLED);
  const { canUsePlaylists, canOpenUserDetails } = useCapabilities();

  return (
    <Switch>
      <Layout>
        {routes.map(({ Page, to }, index) => (
          <Route
            key={index}
            path={to}
            exact
            render={() => {
              if (isExpired && to !== '/' && to !== ACCOUNT_USERS_ROUTE) return <Redirect to="/" />;
              if (to === '/custom-content' && !isCustomContentEnabled) return <Redirect to="/" />;
              if (to === '/custom-content' && !isAccountOwner && !isTeamManager)
                return <Redirect to="/" />;
              if (to === '/playlist/:id' && !canUsePlaylists) return <Redirect to="/playlists" />;
              if (to === '/user/:id' && !canOpenUserDetails) return <Redirect to="/users" />;
              if (isStaff && !staffRoutes.includes(to)) return <Redirect to="/accounts" />;

              return <Page />;
            }}
          />
        ))}
      </Layout>
    </Switch>
  );
};

export { Routes };
